import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Expertise } from 'src/app/shared/models/expertise';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class ExpertiseService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllExpertises(): Observable<Expertise[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.expertiseUrl}/all`,
			'getAllExpertises'
		);
	}

	getExpertisesByServiceAndTypePrestation(idService: number, typePrestation: number): Observable<Expertise[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.expertiseUrl}/getExpertisesByServiceAndTypePrestation/${idService}/${typePrestation}`,
			'getExpertisesByServiceAndTypePrestation'
		);
	}

	importExpertise(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'expertises.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.expertiseUrl}/import`,
			`importExpertise`,
			formData
		);
	}

	getExpertiseById(id: number): Observable<Expertise> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.expertiseUrl}/get/${id}`,
			'getExpertiseById'
		);
	}

	updateExpertise(expertise: Expertise): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.expertiseUrl}/update/${expertise.id}`,
			'updateExpertise',
			expertise
		);
	}

	addExpertise(expertise: Expertise): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.expertiseUrl}/add`,
			'addExpertise',
			expertise
		);
	}

	deleteExpertise(expertiseId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.expertiseUrl}/delete/${expertiseId}`,
			`deleteExpertise`
		);
	}
}
